/** F606 Programs page — training programs library. */
import { ClipboardList } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606ProgramsPage() {
  return (
    <F606DataPage
      entity="programs"
      titleAr="البرامج التدريبية"
      titleEn="Training programs"
      icon={ClipboardList}
      emptyIcon={ClipboardList}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'name',
          ar: 'البرنامج', en: 'Program',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.name || r.title || '—'}</div>
              {r.category && <div className="text-[10px] text-white/40">{r.category}</div>}
            </div>
          ),
        },
        { key: 'trainer_name', ar: 'المدرّب', en: 'Trainer', render: (r) => r.trainer_name || '—' },
        { key: 'duration_days', ar: 'المدة', en: 'Duration', render: (r) => r.duration_days ? `${r.duration_days}d` : (r.duration || '—'), className: 'w-20 text-center' },
        { key: 'enrolled', ar: 'المشتركون', en: 'Enrolled', render: (r) => r.enrolled_count ?? r.subscribers_count ?? '—', className: 'w-20 text-center' },
        {
          key: 'price',
          ar: 'السعر', en: 'Price',
          render: (r) => r.price != null ? <span className="font-mono font-bold text-emerald-300" dir="ltr">{Number(r.price).toFixed(2)} {r.currency || 'AED'}</span> : '—',
          className: 'w-32',
        },
      ]}
    />
  );
}
